import { render, staticRenderFns } from "./LightboxContainer.vue?vue&type=template&id=dece5bb6&scoped=true&"
import script from "./LightboxContainer.vue?vue&type=script&lang=ts&"
export * from "./LightboxContainer.vue?vue&type=script&lang=ts&"
import style0 from "./LightboxContainer.vue?vue&type=style&index=0&id=dece5bb6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dece5bb6",
  null
  
)

export default component.exports